import { useEffect } from 'react';

import useToggle from '../../../../../../hooks/useToggle';
import { isTrue } from '../../../../../../utils';
import useAuthenticationSettingsContext from '../../hooks/useAuthenticationSettingsContext';

const useClaimDomainModal = () => {
  const [isClaimDomainModalOpen, toggleIsClaimDomainModalOpen] = useToggle(false);
  const { location } = useAuthenticationSettingsContext();

  const {
    samlAuthenticated: samlAuthenticatedDomain,
    ssoDomainClaimed: claimedDomain,
    domainVerificationError,
    claimDomain,
  } = location?.query || {};

  const isModalTriggeredExternally =
    !!(samlAuthenticatedDomain || claimedDomain || domainVerificationError) || isTrue(claimDomain);

  // On mount only, check if we should open the modal to display a message telling the user to check their email or that
  // they've claimed a domain.
  useEffect(() => {
    if (isModalTriggeredExternally) {
      toggleIsClaimDomainModalOpen();
    }
  }, [isModalTriggeredExternally, toggleIsClaimDomainModalOpen]);

  return {
    isClaimDomainModalOpen,
    toggleIsClaimDomainModalOpen,
    isModalTriggeredExternally,
  };
};

export default useClaimDomainModal;
